import {
  Button,
  Div,
  EditPenIconRed,
  ErrorToast,
  H5,
  Icon,
  Img,
  ModalPortal,
  P,
  Radio,
  SimpleBrandEntity,
  lightTheme,
  restaurantImage,
} from '@vgrubs/components';
import { SimpleLocationEntity } from 'components/src/types/location.types';
import 'flatpickr/dist/flatpickr.css';
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LocationPart } from './LocationPart';

export const AdminLocationAndBrandPickerModal = ({
  isOpen,
  handleSubmit,
  filterActive,
  onClose,
  changeParams,
}: {
  isOpen: boolean;
  handleSubmit: (
    location: SimpleLocationEntity,
    brand: SimpleBrandEntity
  ) => void;
  filterActive?: boolean;
  onClose: () => void;
  changeParams: () => void;
}) => {
  const [searchParams] = useSearchParams();
  const locationName = searchParams.get('locationName');
  const brandName = searchParams.get('brandName');

  const [selectedLocation, setSelectedLocation] =
    useState<SimpleLocationEntity | null>();
  const [selectedBrand, setSelectedBrand] = useState<SimpleBrandEntity | null>(
    null
  );

  const handleSelectLocation = (newItem: SimpleLocationEntity) => {
    setSelectedLocation(newItem);
  };

  const handleSelectBrand = (newItem: SimpleBrandEntity) => {
    setSelectedBrand(newItem);
  };

  function isLocationSelected(item: SimpleLocationEntity) {
    return selectedLocation?.id === item.id;
  }

  function isBrandSelected(item: SimpleBrandEntity) {
    return selectedBrand?.id === item.id;
  }

  const filteredBrands = selectedLocation?.brands.filter((brand) =>
    brand.name.toLowerCase().includes(''.toLowerCase())
  );

  return (
    <>
      {/* {filterActive && locationName && (
        <Div>
          <P $fs="12px" $m="0" $mtSM={20}>
            Location: <b>{locationName}</b>, Brand: <b>{brandName}</b> |{' '}
            <span
              style={{
                color: lightTheme.primary,
              }}
              onClick={changeParams}
            >
              Change
            </span>
          </P>
        </Div>
      )} */}

      {filterActive && locationName && (
        <Div
          $flex
          $alignCenter
          $gap="8px"
          $mb="16px"
          $mtSM="8"
          $width="100%"
          $widthSM="100%"
        >
          <P
            $right
            $m="0"
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              width: '100%', // fills parent width
            }}
          >
            <b>
              <span>{locationName}</span>
            </b>
          </P>
          <Div $flexNone>
            <P $m="0" $noWrap>
              <b>/ {brandName}</b>
            </P>
          </Div>
          <Icon $pointer onClick={changeParams} $sizeSM="28">
            <EditPenIconRed />
          </Icon>
        </Div>
      )}
      <ModalPortal
        isOpen={isOpen}
        closeModal={onClose}
        modalOverflow="hidden"
        header={selectedLocation ? 'Select Brand' : 'Select Location'}
        overlayBorderRadius={30}
        logo={false}
        footer={
          selectedLocation && (
            <Div $column $flex $gap="8px">
              <Button
                $selected
                $gray
                $w="100%"
                $wSM="100%"
                onClick={() => {
                  setSelectedLocation(null);
                  setSelectedBrand(null);
                }}
              >
                Choose Another Location
              </Button>
              <Button
                $selected
                $w="100%"
                $wSM="100%"
                onClick={() => {
                  // setModalPortalIsOpen((prev) => !prev);
                  if (selectedLocation) {
                    if (selectedBrand) {
                      handleSubmit(selectedLocation, selectedBrand);
                    } else {
                      ErrorToast('Brand must be selected.');
                    }
                  } else {
                    ErrorToast('Location must be selected.');
                  }
                }}
              >
                Confirm
              </Button>
            </Div>
          )
        }
      >
        <Div>
          <Div $minHeight="30vh">
            {selectedLocation && filteredBrands?.length === 0 && (
              <Div
                $flex
                $center
                $column
                $height="calc(70vh - 300px)"
                $heightSM="calc(60vh - 300px)"
              >
                <Img src={restaurantImage} alt="restaurant" $width="250px" />
                <H5>No Brands</H5>
              </Div>
            )}
            {!selectedLocation ? (
              <LocationPart
                handleSelectLocation={handleSelectLocation}
                isLocationSelected={isLocationSelected}
              />
            ) : (
              filteredBrands?.map((brand) => (
                <Div
                  key={brand.id}
                  $box
                  $p="14px 24px"
                  $mb="8"
                  $flex
                  $alignCenter
                  $between
                  onClick={() => handleSelectBrand(brand)}
                  $gap="16px"
                  $pointer
                  // delay={0.1}
                >
                  <div>
                    <P
                      $left
                      $bold
                      $mb="0"
                      $color={isBrandSelected(brand) && lightTheme.primary}
                      $lineHeight="1.2"
                    >
                      {brand.name}
                    </P>
                  </div>

                  <Radio checked={isBrandSelected(brand)} />
                </Div>
              ))
            )}
          </Div>
        </Div>
      </ModalPortal>
    </>
  );
};
